<template>
  <div>
    <!-- Clipping Profile Modal-->
    <CModal
      :closeOnBackdrop="false"
      :show.sync="changeProfileModal"
      add-content-classes="bg-transparent border-0"
    >
      <template #header-wrapper>
        <div></div>
      </template>
      <template #body-wrapper>
        <div class="completeContainer">
          <CRow class="p-2">
            <CCol>
              <p class="text-dark text-center font-weight-bold font-lg">
                SELECTED
              </p>
              <clipper-fixed
                :area="vueClipperFixedArea"
                :ratio="vueClipperFixedRatio"
                :src="imgURL"
                class="my-clipper test123"
                preview="my-preview"
                ref="clipper"
              >
                <div class="placeholder test123" slot="placeholder">
                  No image
                </div>
              </clipper-fixed>
            </CCol>
            <CCol>
              <p class="text-dark text-center font-weight-bold font-lg">
                PREVIEW
              </p>
              <clipper-preview class="my-clipper" name="my-preview">
                <div class="placeholder" slot="placeholder">preview area</div>
              </clipper-preview>
            </CCol>
          </CRow>
          <CRow>
            <CCol>
              <CRow class="mt-3 ml-0 mr-0">
                <CCol class="p-0 mr-1">
                  <CButton
                    @click="changeProfileModal = false"
                    class="fontRobotoDefault cancelChangeProfileModal"
                    >CANCEL</CButton
                  >
                </CCol>
                <CCol class="p-0">
                  <CButton
                    @click="getResult"
                    class="fontRobotoDefault updateChangeProfileModal"
                    >UPDATE</CButton
                  >
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </template>

      <template #footer-wrapper>
        <div />
      </template>
    </CModal>

    <CModal
      :closeOnBackdrop="true"
      :show.sync="profileImage"
      add-content-classes="border-0 bg-grey"
      size="sm"
    >
      <template #header-wrapper>
        <div></div>
      </template>
      <template #body-wrapper>
        <div class="profileImageContainer">
          <div class="mainImageContainer">
            <img :src="userinfo.image_profile" class="mainImage" />
          </div>
          <label class="ml-4 fontRobotoDefault mt-2 font-weight-bold"
            >PROFILE PICTURE</label
          >
          <CRow class="ml-1">
            <CCol style="margin-right: 0.3rem" class="col-sm-3">
              <CRow class="addImageProfileButtonContainer col-sm-12">
                <button class="addImageProfileButton">
                  <clipper-upload v-model="imgURL">
                    <img
                      height="20"
                      src="@/assets/icons/AddProfilePicture.svg"
                      width="20"
                    />
                  </clipper-upload>
                </button>
              </CRow>
            </CCol>

            <div
              :key="index"
              style="margin-right: 2.75rem"
              v-for="(item, index) in userinfo.image_collection"
            >
              <CRow
                @click="changeCurrentImage(index)"
                class="accountImage"
                xl="3"
              >
                <img :src="item.url || ''" class="accountImage" />
                <div class="itemImageSelected" v-if="item.select">
                  <img
                    height="19px"
                    src="@/assets/icons/homepage/sync.svg"
                    width="19x"
                  />
                </div>
              </CRow>
            </div>
          </CRow>
        </div>
      </template>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>

    <!--        Confirm-->
    <CModal
      :centered="true"
      :closeOnBackdrop="false"
      :show.sync="openConfirm"
      add-content-classes="bg-transparent border-0"
    >
      <template #header-wrapper>
        <div @click="openConfirm = false" class="closeBtnContainer">
          <p class="closeButton">
            <img class="closeButtonItem" src="@/assets/icons/closeButton.svg" />
          </p>
        </div>
      </template>
      <template #body-wrapper>
        <div class="completeContainer">
          <CCol class="align-items-center">
            <CRow class="title">
              <label class="fontRobotoDefault font-weight-bold"
                >CAUTION !</label
              >
            </CRow>
            <CRow class="content">
              <label class="fontRobotoDefault"
                >Are you sure to update your profile</label
              >
            </CRow>
            <CRow style="margin-left: 10%">
              <CButton
                @click="openConfirm = false"
                class="fontRobotoDefault cancelConfirmAll"
                >CANCEL</CButton
              >
              <CButton
                @click="updateProfile"
                class="fontRobotoDefault acceptConfirmAll"
                >CONFIRM</CButton
              >
            </CRow>
          </CCol>
        </div>
      </template>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>

    <CRow class="topCard bg-white">
      <CCol class="topCardA col-sm-12">
        <CRow>
          <CCol class="col-sm-4">
            <!-- <CRow class="mt-2" style="cursor: pointer">
              <a
                @click="profileImage = true"
                v-if="
                  userinfo.image_profile == '' || userinfo.image_profile == null
                "
                class="image_no_profile"
                style="font-size: 200px; color: #ccc; "
              >
                <i class="fa fa-user no-userimage"></i>
              </a>
              <img
                v-else
                :src="userinfo.image_profile"
                @click="profileImage = true"
                alt="no image yet"
                class="showImage"
                height="200px"
                width="200px"
              />
            </CRow> -->
            <CRow class="mt-2" >
              <a
                v-if="
                  userinfo.image_profile == '' || userinfo.image_profile == null
                "
                class="image_no_profile"
                style="font-size: 200px; color: #ccc; "
              >
                <i class="fa fa-user no-userimage"></i>
              </a>
              <img
                v-else
                :src="userinfo.image_profile"
                alt="no image yet"
                class="showImage"
                height="200px"
                width="200px"
              />
            </CRow>
            <p v-if="userType == 10">
              <CRow class="mt-2">
                <label class="topicText">MDL Student ID</label>
              </CRow>

              <CRow>
                <label class="font-weight-bold" style="font-size: 20px">{{
                  this.$store.getters["auth/userInformation"].codeId ||
                    "Fill Student ID"
                }}</label>
              </CRow>
            </p>
          </CCol>

          <CCol class="col-sm-8 mt-3 display-name">
            <CRow>
              <CCol class="col-sm-6 pl-0 pr-0">
                <label class="fontRobotoDefault mb-0">DisplayName</label>
                <CRow class="m-0">
                  <label class="contentTextUnderline">{{
                    userinfo.displayname || "Fill displayname"
                  }}</label>
                </CRow>
              </CCol>
              <CCol class="col-sm-6 pl-0 pr-0">
                <CRow class="mt-2">
                  <changeButton
                    :data="displayNameObjects"
                    @confirm="changeDisplayName"
                  />
                </CRow>
              </CCol>
            </CRow>

            <!--
            <CRow style="margin-top: 0.3rem;">
              <input
                class="border-bottom contentTextUnderline textNormal"
                placeholder="Fill displayname"
                v-model="userinfo.displayname"
              />
            </CRow>
            -->
          </CCol>
        </CRow>
        <CRow class="pt-4 d-lg-none hide-xs">
          <CCol class="col-sm-6 pl-0">
            <label class="fontRobotoDefault mb-0">DisplayName</label>
            <CRow class="m-0">
              <label
                style="
                  width: 218px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                class="contentTextUnderline overflow-md"
                >{{ userinfo.displayname || "Fill displayname" }}</label
              >
            </CRow>
          </CCol>
          <CCol class="col-sm-6 pl-0 pr-0">
            <CRow class="mt-2">
              <changeButton
                :data="displayNameObjects"
                @confirm="changeDisplayName"
              />
            </CRow>
          </CCol>
        </CRow>
        <CRow class="pt-4">
          <CCol class="col-sm-6">
            <CRow>
              <label class="topicText">E-mail</label>
            </CRow>
            <CRow>
              <label class="contentTextUnderline nowrap overflow-hidden">{{
                userinfo.email.name
              }}</label>
            </CRow>
          </CCol>
          <!--
          <CCol col="6">
            <CRow style="margin-top: 0.5rem;">
              <changeButton :data="emailObjects" @confirm="changeEmail" />
            </CRow>
          </CCol>
          -->
        </CRow>

        <CRow class="pt-4">
          <CCol class="col-sm-6">
            <CRow>
              <label class="topicText">Username</label>
            </CRow>
            <CRow>
              <label class="contentTextUnderline">{{ username }}</label>
            </CRow>
          </CCol>
          <CCol class="col-sm-6 pl-0 pr-0">
            <CRow class="mt-2">
              <changeButton
                :data="usernameObjects"
                class="pl-0 pr-0 ml-0"
                @confirm="changeUsername"
                :updateDataSuccess="updateDataSuccess"
              />
            </CRow>
          </CCol>
        </CRow>

        <CRow class="pt-4 pb-4">
          <CCol class="col-sm-6">
            <CRow>
              <label class="topicText">Phone Number</label>
            </CRow>
            <CRow>
              <label class="contentTextUnderline">{{
                userinfo.msisdn || "Fill phone"
              }}</label>
            </CRow>
          </CCol>
          <CCol class="col-sm-6 pl-0 pr-0 pl-0">
            <CRow class="mt-2">
              <changeButton :data="phoneObjects" @confirm="changePhone" />
            </CRow>
          </CCol>
        </CRow>
      </CCol>

      <!--
      <CCol xl="4">
        <div class="w-50">
         
          <CRow style="margin-top: 2.5rem;">
            <CCol>
              <label class="topicText">Citizen ID card</label>
              <br/>
              <div class="citizenPlaceHolder"></div>
              <label class="topicText" style="margin-top: 1.4rem">Citizen ID Status</label>
              <CRow style="margin-top: 0.5rem">
                <CCol col="1">
                  <div class="approvedSign"/>
                </CCol>
                <CCol col="10">
                  <label style="font-size: 20px">
                    <strong>APPROVED</strong>
                  </label>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          
          <CRow>
            <Facebook style="width: 270px; margin-left: 1rem"/>
          </CRow>
          <CRow style="margin-top: 1rem; margin-left: 1rem">
            <viaGoogle/>
          </CRow>
        </div>
      </CCol>-->
      <img src="@/assets/icons/lineDotted.png" class="dotted" />
      <CCol class="bottomContainer">
        <CRow class="mt-4">
          <CCol class="breakingText col-sm-4">
            <CRow>
              <CCol>
                <CRow class="topicText">Name</CRow>
                <CRow>
                  <input
                    :disabled="userType === 10"
                    class="border-bottom contentTextUnderline textNormal col-11"
                    placeholder="Fill Firstname"
                    v-model="firstName"
                  />
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol class="breakingText col-sm-4">
            <CRow>
              <CCol>
                <CRow class="topicText">Surname</CRow>
                <CRow>
                  <input
                    :disabled="userType === 10"
                    class="border-bottom contentTextUnderline textNormal col-11"
                    placeholder="Fill Surname"
                    v-model="lastName"
                  />
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol class="col-sm-4">
            <CRow>
              <CCol>
                <CRow class="topicText">Gender</CRow>
                <CRow>
                  <select
                    class="contentTextUnderline userDataA"
                    v-model="userinfo.gender"
                    :disabled="userType === 10"
                  >
                    <option :value="null" disabled>select gender</option>
                    <option
                      :key="index"
                      v-bind:value="item.val"
                      v-for="(item, index) in this.gender"
                    >
                      {{ item.val }}
                    </option>
                  </select>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol class="breakingText col-sm-4 col-12">
            <CRow>
              <CCol>
                <CRow class="topicText">Birthday</CRow>
                <CRow class="w-100">
                  <CCol class="nonePaddingHorizontal breakingTextDate">
                    <select
                      class="contentTextUnderline userDataA"
                      v-model="userinfo.birthday.date"
                      :disabled="userType === 10"
                    >
                      <option :value="null" disabled>DD</option>
                      <option
                        :key="index"
                        v-bind:value="item"
                        v-for="(item, index) in birthday.day"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </CCol>
                  <CCol class="nonePaddingHorizontal breakingTextDate" col="3">
                    <select
                      :disabled="userType === 10"
                      class="contentTextUnderline userDataA"
                      v-model="userinfo.birthday.month"
                    >
                      <option :value="null" disabled>MM</option>
                      <option
                        :key="index"
                        v-bind:value="item"
                        v-for="(item, index) in this.birthday.month"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </CCol>
                  <CCol class="nonePaddingHorizontal" col="6">
                    <select
                      :disabled="userType === 10"
                      class="contentTextUnderline userDataA breakingTextDate"
                      v-model="userinfo.birthday.year"
                    >
                      <option :value="null" disabled>YYYY</option>
                      <option
                        :key="index"
                        v-bind:value="item"
                        v-for="(item, index) in this.birthday.year"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol class="breakingText col-sm-4">
            <CRow>
              <CCol>
                <CRow class="topicText">Age</CRow>
                <CRow class="ageDisplay">{{ age }}</CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol class="col-sm-4">
            <CRow>
              <CCol>
                <CRow class="topicText">Citizen ID</CRow>
                <CRow>
                  <input
                    :disabled="userType === 10"
                    class="border-bottom contentTextUnderline textNormal"
                    placeholder="Fill citizen id"
                    v-model="userinfo.card_id"
                  />
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="userinfo.address.country.length > 0">
          <CCol class="col-sm-4">
            <CRow>
              <CCol>
                <CRow class="topicText">Country</CRow>
                <CRow>
                  <select
                    class="contentTextUnderline userDataA"
                    v-model="userinfo.address.country[0].val"
                    :disabled="userType === 10"
                  >
                    <option :value="null" disabled>
                      {{ userinfo.address.country[0].val }}
                    </option>
                    <option
                      :key="index"
                      v-bind:value="item.val"
                      v-for="(item, index) in this.countryTest"
                    >
                      {{ item.val }}
                    </option>
                  </select>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol class="col-sm-4">
            <CRow>
              <CCol>
                <CRow class="topicText">Zipcode</CRow>
                <CRow>
                  <div v-if="userType === 10">
                    <input
                      disabled
                      class="border-bottom contentTextUnderline textNormal"
                      placeholder="Fill address"
                      v-model="userinfo.address.zipcode"
                    />
                  </div>
                  <ThailandAutoComplete
                    v-else
                    @select="select"
                    class="topicText"
                    placeholder="Zipcode"
                    size="small"
                    type="zipcode"
                    v-model="userinfo.address.zipcode"
                  />
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol
            class="breakingText"
            xl="4"
            v-if="this.userinfo.address.province != null"
          >
            <CRow>
              <CCol>
                <CRow class="topicText">Province / State</CRow>
                <CRow>
                  <ThailandAutoComplete
                    @select="select"
                    class="fontRobotoDefault"
                    placeholder="Province"
                    size="small"
                    type="province"
                    v-model="this.userinfo.address.province[0].val"
                  />
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol
            class="col-sm-4 col-12"
            v-if="this.userinfo.address.district != null"
          >
            <CRow>
              <CCol>
                <CRow class="topicText">District</CRow>
                <CRow>
                  <ThailandAutoComplete
                    @select="select"
                    class="fontRobotoDefault"
                    placeholder="District"
                    size="small"
                    type="amphoe"
                    v-model="userinfo.address.district[0].val"
                  />
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol
            class="breakingText col-sm-4"
            v-if="this.userinfo.address.subDistrict != null"
          >
            <CRow>
              <CCol>
                <CRow class="topicText">sub-District</CRow>
                <CRow>
                  <ThailandAutoComplete
                    :disabled="userType === 10"
                    @select="select"
                    class="fontRobotoDefault"
                    placeholder="Sub-district"
                    size="small"
                    type="district"
                    v-model="userinfo.address.subDistrict[0].val"
                  />
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <CRow class="topicText">Address</CRow>
            <CRow>
              <input
                :disabled="userType === 10"
                class="border-bottom contentTextUnderline textNormal"
                placeholder="Fill address"
                v-model="addressDescription"
              />
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol class="col-sm-4">
            <CRow class="topicText">Career</CRow>
            <CRow>
              <select
                class="contentTextUnderline userDataA"
                v-model="userinfo.career"
                :disabled="userType === 10"
              >
                <option :value="null" disabled>Select career</option>
                <option
                  :key="index"
                  v-bind:value="item.val"
                  v-for="(item, index) in this.career"
                >
                  {{ item.val }}
                </option>
              </select>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="userinfo.career == 'Student'">
          <CCol class="col-sm-4">
            <CRow class="topicText">University</CRow>
            <CRow>
              <input
                :disabled="userType === 10"
                class="border-bottom contentTextUnderline textNormal"
                placeholder="Fill University"
                v-model="educationName"
              />
            </CRow>
          </CCol>
          <CCol class="breakingText col-sm-4">
            <CRow class="topicText">School / Faculty</CRow>
            <CRow>
              <input
                :disabled="userType === 10"
                class="border-bottom contentTextUnderline textNormal"
                placeholder="Fill School/Faculty"
                v-model="educationFaculty"
              />
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="userinfo.career == 'Student'">
          <CCol class="col-sm-4">
            <CRow class="topicText">Major</CRow>
            <CRow>
              <input
                :disabled="userType === 10"
                class="border-bottom contentTextUnderline textNormal"
                placeholder="Fill Major"
                v-model="educationDepartment"
              />
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mt-5 mb-5">
          <CCol class="text-right col-sm-6">
            <CButton class="cancelButton">
              <strong>CANCEL</strong>
            </CButton>
          </CCol>
          <CCol class="col-sm-6">
            <CButton @click="openConfirm = true" class="updateButton">
              <strong>UPDATE</strong>
            </CButton>
          </CCol>
        </CRow>
        <CModal
          :centered="true"
          :closeOnBackdrop="false"
          :show.sync="openComplete"
          add-content-classes="bg-transparent border-0"
        >
          <template #header-wrapper>
            <div @click="openComplete = false" class="closeBtnContainer">
              <p class="closeButton">
                <img
                  @click="openComplete = false"
                  src="@/assets/icons/closeButton.svg"
                  style="background-color: white; border-radius: 50%"
                />
              </p>
            </div>
          </template>
          <template #body-wrapper>
            <div class="completeContainer">
              <CCol style="align-items: center">
                <CRow class="title">
                  <label class="textButtonFont" style="font-weight: bold"
                    >COMPLETE!</label
                  >
                </CRow>
                <CRow class="content">
                  <label class="textButtonFont">
                    Changing your user information has been completed!
                  </label>
                </CRow>
                <CRow class="completeButton">
                  <CButton
                    @click="acceptCompleteModal"
                    class="textButtonFont"
                    style="
                      border-radius: 24px;
                      width: 40%;
                      background-color: #0080ff;
                      color: white;
                      font-weight: bold;
                    "
                    >OK</CButton
                  >
                </CRow>
              </CCol>
            </div>
          </template>
          <template #footer-wrapper>
            <div />
          </template>
        </CModal>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
// import Facebook from "./ViaFacebook";
import Complete from "./modal/Complete";
import ConfirmUpdate from "./modal/ConfirmUpdate";
import VerifyCode from "./modal/VerifyCode";
import changeButton from "./modal/ChangeButton";
import ProfileImage from "./modal/ProfileImage";
import viaGoogle from "./ViaGoogle";
import { mapGetters } from "vuex";
import Service from "../../service/api.js";
import store from "../../store/store";
import country from "../../assets/json/country.json";


export default {
  data() {
    return {
      updateDataSuccess: false,
      educationName: "",
      educationFaculty: "",
      educationDepartment: "",
      lastName: "",
      firstName: "",
      addressDescription: "",
      subDistrict: "",
      district: "",
      province: "",
      userinfo: {
        career: this.$store.getters["auth/userInformation"].userinfo.career,
        displayname: "",
        firstname: this.$store.getters["auth/userInformation"].userinfo
          .firstname,
        lastname: this.$store.getters["auth/userInformation"].userinfo.lastname,
        gender: this.$store.getters["auth/userInformation"].userinfo.gender,
        image_profile: this.$store.getters["auth/userInformation"].userinfo
          .image_profile,
        image_collection: this.$store.getters["auth/userInformation"].userinfo
          .image_collection,
        card_id: this.$store.getters["auth/userInformation"].userinfo.card_id,
        birthday: this.$store.getters["auth/userInformation"].userinfo.birthday,
        msisdn: this.$store.getters["auth/userInformation"].userinfo.msisdn,
        email: this.$store.getters["auth/userInformation"].userinfo.email,
        // facebook: this.$store.getters["auth/userInformation"].userinfo.facebook,
        google: this.$store.getters["auth/userInformation"].userinfo.google,
        address: this.$store.getters["auth/userInformation"].userinfo.address,
        codeId: this.$store.getters["auth/userInformation"].codeId,
      },
      username: this.$store.getters["profile/getUsername"],
      age: 0,
      education: this.$store.getters["auth/userInformation"].education,
      openComplete: false,
      openConfirm: false,
      vueClipperFixedRatio: 1,
      vueClipperFixedArea: 50,
      changeProfileModal: false,
      // changeProfileModal: false,
      imgURL: "",
      resultURL: "",
      imageData: "",
      profileImage: false,
      // district: "",
      amphoe: "",
      // province: "",
      zipcode:
        this.$store.getters["auth/userInformation"].userinfo.zipcode || "",
      gender: [{ val: "Female" }, { val: "Male" }],
      // country: [{ val: "Thailand" }, { val: "US" }],
      countryTest: country.country,
      countryHolder: [],
      career: [{ val: "Student" }, { val: "Teacher" }],
      birthday: {
        day: [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
        ],
        month: [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
        ],
        year: [],
      },
      usernameObjects: {
        title: "CHANGE USERNAME",
        description:
          "For your security, if you change your username your saved username will be changed.",
        inputText: this.$store.getters["profile/getUsername"],
        placeholder: "Enter your new username",
        completedDescription: "Changing your username is completed",
      },
      emailObjects: {
        title: "CHANGE E-MAIL",
        description:
          "For your security, if you change your email address your saved credit card information will be deleted.",
        inputText: this.$store.getters["auth/userInformation"].userinfo.email
          .name,
        placeholder: "Enter your new e-mail",
        completedDescription: "Changing your e-mail is completed",
      },
      phoneObjects: {
        title: "CHANGE PHONE NUMBER",
        description:
          "For your security, if you change your phone number your saved phone number will be changed.",
        inputText: this.$store.getters["auth/userInformation"].userinfo.msisdn,
        placeholder: "Enter your new phone number",
        completedDescription: "Changing your phone number is completed",
      },
      displayNameObjects: {
        title: "CHANGE DISPLAY NAME",
        description:
          "For your security, if you change your displayname your displayname will be changed.",
        inputText: this.$store.getters["auth/userInformation"].userinfo
          .displayname,
        placeholder: "Enter your new displayname",
        completedDescription: "Changing your displayname is completed",
      },
    };
  },
  filters: {
    findGender(val) {
      if (val == 0) {
        return "Male";
      } else if (val == 1) {
        return "Female";
      }
    },
  },
  computed: {
    ...mapGetters({
      userInfo: "profile/getProfile",
      userUsername: "profile/getUsername",
      userType: "profile/getUserType",
      userInformation: "auth/userInformation",
    }),
  },
  watch: {
    userInformation: function(val) {
      if (this.$store.getters["auth/userStatus"]) {
        this.$store.dispatch("profile/getUserProfile");
      }
    },
    userInfo(value) {
      this.userinfo = value.userinfo;
      // this.countryHolder = this.userinfo.address.country[0].val;

      if (
        value.userinfo.address != null &&
        value.userinfo.address != undefined
      ) {
        if (value.userinfo.address.country.length === 0) {
          this.userinfo.address.country.push({
            key: "en",
            val: "Thailand",
          });
        }
      }

      if (value.education.name[0].val !== undefined) {
        this.educationName = value.education.name[0].val;
      }
      if (value.education.faculty[0].val !== undefined) {
        this.educationFaculty = value.education.faculty[0].val;
      }
      if (value.education.department[0].val !== undefined) {
        this.educationDepartment = value.education.department[0].val;
      }
      if (value.userinfo.career[0].val !== undefined) {
        this.userinfo.career = value.userinfo.career[0].val;
      }
      if (value.userinfo.gender == 0) {
        this.userinfo.gender = "Male";
      }
      if (value.userinfo.gender == 1) {
        this.userinfo.gender = "Female";
      }
    },
    userUsername(value) {
      this.username = value;
    },
    imgURL: function() {
      this.profileImage = false;
      this.changeProfileModal = true;
    },
    userinfo: {
      handler(val) {
        if (val.address.zipcode == null) {
          val.address.zipcode = "";
        }
        if (!val.address.province.length) {
          let norm = {
            key: "en",
            val: "",
          };
          val.address.province.push(norm);
        }

        if (!val.address.subDistrict.length) {
          let norm = {
            key: "en",
            val: "",
          };
          val.address.subDistrict.push(norm);
        }

        if (!val.address.district.length) {
          let norm = {
            key: "en",
            val: "",
          };
          val.address.district.push(norm);
        }
        // if(!val.address.province[0]) {
        //   val.address.province[0].val= ""
        // }

        // if(!val.address.district[0]) {
        //   val.address.district[0].val= ""
        // }

        // if(!val.address.subDistrict[0]) {
        //   val.address.subDistrict[0].val= ""
        // }

        // alert(val.address.zipcode)
      },
      deep: true,
    },
    // "userinfo.address.zipcode"(value) {
    //   if(value== null) {
    //     alert('No zipcode')
    //     this.userinfo.address.zipcode= ""
    //   }
    // },
    "userinfo.birthday.month"(value) {
      if (
        value === "01" ||
        value === "03" ||
        value === "05" ||
        value === "07" ||
        value === "08" ||
        value === "10" ||
        value === "12"
      ) {
        this.birthday.day = [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
        ];
      } else if (value === "02") {
        if (parseInt(this.userinfo.birthday.year) % 4 === 0) {
          this.birthday.day = [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
          ];
        } else {
          this.birthday.day = [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
          ];
        }
      } else {
        this.birthday.day = [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
        ];
      }
    },
    "userinfo.birthday.year"(value) {
      this.age = new Date().getFullYear() - this.userinfo.birthday.year;
      if (parseInt(value) % 4 === 0 && this.userinfo.birthday.month === "02") {
        this.birthday.day = [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
        ];
      } else if (
        parseInt(value) % 4 !== 0 &&
        this.userinfo.birthday.month === "02"
      ) {
        this.birthday.day = [
          "01",
          "02",
          "03",
          "04",
          "05",
          "06",
          "07",
          "08",
          "09",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
        ];
      }
    },
  },
  created() {
    let date = new Date().getFullYear();

    for (let i = date; i >= date - 100; i--) {
      this.birthday.year.push(i);
    }
  },
  mounted() {
    // if (
    //     this.userinfo.address.zipcode === null ||
    //     this.userinfo.address.subDistrict === null ||
    //     this.userinfo.address.district === null ||
    //     this.userinfo.address.province === null
    // ) {
    //   this.userinfo.address.zipcode = "";
    //   this.userinfo.address.subDistrict = "";
    //   this.userinfo.address.district = "";
    //   this.userinfo.address.province = "";
    // }
    if (this.$store.getters["auth/userStatus"]) {
      this.$store.dispatch("profile/getUserProfile");
    }
    let date = new Date().getFullYear();
    if (this.userinfo.birthday.year) {
      this.age =
        date -
        this.$store.getters["auth/userInformation"].userinfo.birthday.year;
    } else this.age = "Fill your birthdate";
    this.checkLanguage();
  },
  methods: {
    acceptCompleteModal() {
      this.openComplete = false;
    },
    changeUsername(value) {
      let body = {
        Username: value,
      };
      Service.onUpdateUsername(body)
        .then((res) => {
          store.commit("profile/setUpdateUsername", value);
          this.updateDataSuccess = true;
        })
        .catch();
    },
    changeDisplayName(val) {
      const body = {
        displayname: val,
      };
      this.$store.dispatch("updateProfile/onUpdateDisplaynameProfile", body);
      this.userinfo.displayname = val;
    },
    changeEmail(value) {
      alert(value);
    },
    changePhone(value) {
      this.userinfo.msisdn = value;
      //this.updateProfile();
      const body = {
        msisdn: this.userinfo.msisdn,
      };
      this.$store.dispatch("updateProfile/onUpdatePhoneNumber", body);
    },
    checkLanguage() {
      if (this.education.name) {
        for (let index = 0; index < this.education.name.length; index++) {
          const EducationName = this.education.name[index];
          if (EducationName.key == "en") {
            this.educationName = EducationName.val;
          }
        }
      }
      if (this.education.faculty) {
        for (let index = 0; index < this.education.faculty.length; index++) {
          const FaculityName = this.education.faculty[index];
          if (FaculityName.key == "en") {
            this.educationFaculty = FaculityName.val;
          }
        }
      }
      if (this.education.department) {
        for (let index = 0; index < this.education.department.length; index++) {
          const EducationDepartment = this.education.department[index];
          if (EducationDepartment.key == "en") {
            this.educationDepartment = EducationDepartment.val;
          }
        }
      }
      if (this.userinfo.lastname) {
        for (let index = 0; index < this.userinfo.lastname.length; index++) {
          const LastName = this.userinfo.lastname[index];
          if (LastName.key == "en") {
            this.lastName = LastName.val;
          }
        }
      }
      if (this.userinfo.firstname) {
        for (let index = 0; index < this.userinfo.firstname.length; index++) {
          const FirstName = this.userinfo.firstname[index];
          if (FirstName.key == "en") {
            this.firstName = FirstName.val;
          }
        }
      }
      if (this.userinfo.address.description) {
        for (
          let index = 0;
          index < this.userinfo.address.description.length;
          index++
        ) {
          const AddressDescription = this.userinfo.address.description[index];
          if (AddressDescription.key == "en") {
            this.addressDescription = AddressDescription.val;
          }
        }
      }
      if (this.userinfo.address.subDistrict) {
        for (
          let index = 0;
          index < this.userinfo.address.subDistrict.length;
          index++
        ) {
          const SubDistrict = this.userinfo.address.subDistrict[index];
          if (SubDistrict.key == "en") {
            this.subDistrict = SubDistrict.val;
          }
        }
      }
      if (this.userinfo.address.district) {
        for (
          let index = 0;
          index < this.userinfo.address.district.length;
          index++
        ) {
          const District = this.userinfo.address.district[index];
          if (District.key == "en") {
            this.district = District.val;
          }
        }
      }
      if (this.userinfo.address.province) {
        for (
          let index = 0;
          index < this.userinfo.address.province.length;
          index++
        ) {
          const Province = this.userinfo.address.province[index];
          if (Province.key == "en") {
            this.province = Province.val;
          }
        }
      }
    },
    updateProfile() {
      if (this.userinfo.gender === "Male") this.userinfo.gender = 0;
      if (this.userinfo.gender === "Female") this.userinfo.gender = 1;
      let body = {
        userinfo: {
          displayname: this.userinfo.displayname,
          firstname: [
            {
              val: this.firstName,
              key: "en",
            },
          ],
          career: [
            {
              key: "en",
              val: this.userinfo.career,
            },
          ],
          gender: this.userinfo.gender,
          lastname: [
            {
              key: "en",
              val: this.lastName,
            },
          ],
          image_profile: this.userinfo.image_profile,
          image_collection: this.userinfo.image_collection,
          card_id: this.userinfo.card_id,
          birthday: this.userinfo.birthday,
          msisdn: this.userinfo.msisdn,
          email: {
            name: this.userinfo.email.name,
            verification: "",
            secret: "",
            otp: "",
          },
          // facebook: {
          //   id: "",
          //   email: "",
          //   token: "",
          // },
          google: {
            id: "",
            email: "",
            token: "",
          },
          address: {
            country: [
              {
                key: "en",
                val: this.userinfo.address.country[0].val,
              },
            ],
            province: [
              {
                key: "en",
                val: this.userinfo.address.province[0].val,
              },
            ],
            district: [
              {
                key: "en",
                val: this.userinfo.address.district[0].val,
              },
            ],
            subDistrict: [
              {
                key: "en",
                val: this.userinfo.address.subDistrict[0].val,
              },
            ],
            zipcode: this.userinfo.address.zipcode,
            description: [
              {
                key: "en",
                val: this.addressDescription,
              },
            ],
          },
        },
        education: {
          name: [
            {
              key: "en",
              val: this.educationName,
            },
          ],
          faculty: [
            {
              key: "en",
              val: this.educationFaculty,
            },
          ],
          department: [
            {
              key: "en",
              val: this.educationDepartment,
            },
          ],
        },
      };
      this.$store.dispatch("updateProfile/onUpdateProfile", body);
      this.openConfirm = false;
      this.openComplete = true;
    },
    getResult() {
      const canvas = this.$refs.clipper.clip(); //call component's clip method
      this.userinfo.image_profile = canvas.toDataURL("image/jpeg", 1); //canvas->image

      let i;
      for (i = 0; i < this.userinfo.image_collection.length; i++) {
        this.userinfo.image_collection[i].select = false;
      }
      let payload = {
        url: this.userinfo.image_profile,
        select: true,
      };
      this.userinfo.image_collection.unshift(payload);
      if (this.userinfo.image_collection.length > 3) {
        this.userinfo.image_collection.pop();
      }
      this.changeProfileModal = false;
      const body = {
        imageProfile: this.userinfo.image_profile,
      };
      // this.$store.dispatch("updateProfile/onUpdateImgProfile", body);
    },
    select(address) {
      this.userinfo.address.subDistrict[0].val = address.district;
      this.userinfo.address.district[0].val = address.amphoe;
      this.userinfo.address.province[0].val = address.province;
      this.userinfo.address.zipcode = address.zipcode;
    },
    // closeModal() {
    //     this.openChangePassword = false
    //     this.openVerify = false
    //     this.openComplete = false
    // },
    // changeEmailMainPage() {
    //     this.openChangeEmail = true
    // },
    // VerifyFunction() {
    //     this.openChangeEmail = false
    //     this.openVerify = true
    // },
    // CompleteFunction() {
    //     this.openVerify = false
    //     this.openComplete = true
    // },
    changeCurrentImage(index) {
      let i;
      for (i = 0; i < this.userinfo.image_collection.length; i++) {
        this.userinfo.image_collection[i].select = false;
      }
      this.userinfo.image_collection[index].select = true;
      this.userinfo.image_profile = this.userinfo.image_collection[index].url;
      const body = {
        imageProfile: this.userinfo.image_profile,
      };
      // this.$store.dispatch("updateProfile/onUpdateImgProfile", body);
    },
  },
  components: {
    // Facebook,
    ThailandAutoComplete,
    Complete,
    ConfirmUpdate,
    VerifyCode,
    changeButton,
    viaGoogle,
    ProfileImage,
  },
};
</script>
<style scoped>
.textButtonFont {
  font-family: Roboto;
}

div .citizenPlaceHolder {
  height: 170px;
  width: 270px;
  background-color: #ace4eb;
  border-radius: 20px;
  margin-top: 0.75rem;
}

.topicText {
  font-size: 16px;
  margin-bottom: 0px;
  font-family: Roboto;
}

.contentTextUnderline {
  font-size: 20px;
  margin-bottom: 0rem;
  border-bottom: 1px solid #cccccc !important;
  width: 80%;
  font-weight: bold;
  font-family: Roboto;
}

.textNormal {
  border: 0;
  outline: 0;
  background: transparent;
}

hr {
  border: none;
  border-top: 20px dotted #b3b3b3;
  color: #fff;
  background-color: transparent;
  height: 1px;
  width: 100%;
  margin: 0;
  z-index: 1;
}

.topCard {
  border-bottom-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 24px 5px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 24px 5px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 24px 5px rgba(204, 204, 204, 1);
  border-color: #cccccc;
}

.bottomCard {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 51px 5px rgba(204, 204, 204, 1);
  border-color: #cccccc;
}

.underline {
  border: 0;
  outline: 0;
  background: transparent;
  width: 100%;
}

.closeBtnContainer {
  padding-right: 1rem;
}

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.completeContainer {
  width: 80%;
  border-radius: 20px;
  background-color: white;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
  align-self: center;
}

.title {
  color: black;
  justify-content: center;
  font-family: Roboto;
  margin-bottom: 0.8rem;
  font-size: 1.28rem;
}

.content {
  color: black;
  justify-content: center;
  font-family: "Roboto Light";
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.completeButton {
  justify-content: center;
}

.textInput {
  border: 0px;
  border-bottom: 1px solid #ccc;
  width: 80%;
}

.mainImageContainer {
  height: 380px;
}

.mainImage {
  /*top: 0;*/
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
}

/*
        img {

        } */

.addProfileImage {
  width: 80px;
  height: 80px;
  background-color: #efefef;
  border-radius: 10px;
  /* margin-top: 8%; */
}

.accountImage {
  object-fit: cover;
  width: 80px;
  height: 80px;
  background-color: green;
  border-radius: 10px;
  background: transparent 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 5px #00000029;
}

.accountImage:hover {
  cursor: pointer;
}

.profileImageContainer {
  background-color: white;
  border-radius: 30px !important;
  padding-bottom: 1.75rem;
  align-self: center;
  width: 380px;
}

/*    add image profile*/
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 12px 18px;
  cursor: pointer;
}

.showImage {
  border-radius: 0.5rem;
  object-fit: cover;
}

.showImage:hover {
  -webkit-filter: brightness(80%);
  /*-webkit-transition: all 0.5s ease;*/
  /*-moz-transition: all 0.5s ease;*/
  /*-o-transition: all 0.5s ease;*/
  /*-ms-transition: all 0.5s ease;*/
  /*transition: all 0.5s ease;*/
}

/*Clipper CSS*/
.my-clipper {
  width: 100%;
  max-width: 700px;
}

.placeholder {
  text-align: center;
  padding: 20px;
  background-color: lightgray;
}

/*Clipper CSS*/
.updateChangeProfileModal {
  float: left;
  background-color: #0080ff;
  color: white;
  font-weight: bold;
  border-radius: 12px;
  width: 60%;
}

.cancelChangeProfileModal {
  float: right;
  background-color: #b2b2b2;
  color: white;
  font-weight: bold;
  border-radius: 12px;
  width: 60%;
  margin-right: 0.5rem;
}

.userDataA {
  border: 0;
  width: 80%;
  border-bottom: 1px solid #ccc;
}

.ageDisplay {
  font-size: 20px;
  margin-bottom: 0rem;
  width: 80%;
  font-weight: bold;
}

.addImageProfileButtonContainer {
  margin-right: auto;
  margin-left: auto;
  margin-top: 0.5rem;
}

.addImageProfileButton {
  background-color: #efefef;
  border-radius: 10px;
  border: 0;
  height: 60px;
  box-shadow: 5px 5px 5px #00000029;
  opacity: 1;
  width: 4rem;
}

.itemImageSelected {
  margin-left: 4.2rem;
  margin-top: -1rem;
}

.bottomContainer {
  padding-left: 4rem;
  margin-top: 2.5rem;
  padding-top: -1.3rem;
}

.approvedSign {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: #5aba6a;
  margin-top: 0.345rem;
}

.closeButtonItem {
  background-color: white;
  border-radius: 50%;
}

.cancelConfirmAll {
  background-color: #b2b2b2;
  color: white;
  font-weight: bold;
  border-radius: 24px;
  width: 40%;
  margin-right: 0.5rem;
}

.acceptConfirmAll {
  background-color: #0080ff;
  color: white;
  font-weight: bold;
  border-radius: 24px;
  width: 40%;
  margin-left: 0.5rem;
}

.topCardA {
  padding-left: 4rem;
  margin-top: 1.5rem;
}

.changeButton {
  background-color: #0080ff;
  width: 150px;
  height: 50px;
  border-radius: 0.5rem;
  color: white;
}

::placeholder {
  color: black;
}

.dotted {
  width: 100%;
}

@media only screen and (max-width: 426px) {
  .changePasswordContainer {
    width: auto;
    padding: 0 2rem;
    margin-right: auto;
    margin-left: auto;
  }

  .cancelButton,
  .updateButton {
    /* display: inline-block !important; */
    width: 120px !important;
    float: left !important;
  }

  .bottomContainer {
    margin: auto;
    padding-left: 2rem;
    /* padding-left: 3rem; */
  }

  .breakingText {
    margin-top: 1.75rem;
  }

  .breakingTextDate {
    margin-top: 1rem;
  }
}

@media screen and (max-width: 415px) {
  .image_no_profile {
    margin: 0 auto;
  }
}

@media only screen and (width: 375px) {
  .showImage {
    margin-left: 3em;
  }
  .hide-xs {
    display: none;
  }
}

@media only screen and (max-width: 450px) {
  .displayname-responsive {
    display: none;
  }
  .topCardA {
    padding-left: 25px;
  }
  .hide-xs {
    display: none;
  }
  .contentTextUnderline {
    float: left;
    font-size: 20px;
    border-bottom: 1px solid #cccccc !important;
    width: 250px;
    font-weight: bold;
    font-family: Roboto;
  }
  .showImage {
    margin-left: 4.5em;
  }
  .userDataA {
    border: 0;
    width: 80%;
    border-bottom: 1px solid #ccc;
  }
}
@media only screen and (width: 768px) {
  .dotted {
    width: 100%;
  }
  .userDataA {
    border: 0;
    width: 80%;
    border-bottom: 1px solid #ccc;
  }
  .display-name {
    display: none;
  }
}
@media only screen and (width: 812px) {
  .display-name {
    display: none;
  }
}
@media only screen and (max-width: 450px) {
  .overflow-md {
    width: 218px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
